export default __webpack_public_path__ + "1fd93f96bc289095b25d090ca5819abf.png";